import React, { useState } from 'react';

import { ReactComponent as Eye } from '../../../assets/icons/Eye.svg';
import { ReactComponent as EyeClosed } from '../../../assets/icons/EyeClosed.svg';

import classes from './Password.module.scss';

const Password = ({ value, error, onChange, ...props }) => {
  const [isVisiblePassword, setIsVisiblePassword] = useState(false);

  const setVisiblePasswordHandler = () => {
    setIsVisiblePassword(isVisible => !isVisible);
  };
  return (
    <div className={`${classes.div}`}>
      <input
        {...props}
        className={`${error ? 'input-error' : 'input-text'} ${classes.content} medium-16`}
        value={value}
        type={isVisiblePassword ? 'text' : 'password'}
        onChange={event => onChange(event.target.value)}
      />
      {isVisiblePassword ? (
        <EyeClosed onClick={setVisiblePasswordHandler} className={`pointer ${classes.icon}`} />
      ) : (
        <Eye onClick={setVisiblePasswordHandler} className={`pointer ${classes.icon}`} />
      )}
    </div>
  );
};

export default Password;
